const state = {
  focusedTick: null,
}

const mutations = {
  SET_DATE (state, date) {
    state.today = date
  },
  SET_FOCUSED_TICK (state, tick) {
    state.focusedTick = tick
  },
}

const actions = {
  setFocusedTick ({commit}, tick) {
    commit('SET_FOCUSED_TICK', tick)
  },
  clearFocusedTick ({commit}) {
    commit('SET_FOCUSED_TICK', null)
  },
}

const getters = {
  focusedTick: state => state.focusedTick,
}

export default {
  actions,
  getters,
  mutations,
  state,
  namespaced: true,
}



// WEBPACK FOOTER //
// ./src/store/modules/reservation.js